(function (angular) {
    angular.module('one.admin').controller('AddListModuleModalController', AddListModuleModalController);

    AddListModuleModalController.$inject = ['$scope', '$uibModalInstance', 'ModuleService', 'params'];

    function AddListModuleModalController($scope, $uibModalInstance, ModuleService, params) {
        $scope.module = {
            module_instance: {
                brand: 'default',
                layout: 'columns',
                icon_alignment: 'left',
                icon_brand: 'default',
                items: [
                    {
                        content: '',
                        position: 1,
                        new_window: false
                    }
                ]
            }
        };

        angular.merge($scope, params);

        $scope.addListModule = addListModule;

        $scope.cancel = cancel;

        function addListModule(data) {
            ModuleService.addModule(data).then(function (data) {
                $uibModalInstance.close(data);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})(angular);
